import { call, put, takeLatest } from 'redux-saga/effects';
import TicketApprovalAction, { TicketApprovalTypes } from 'redux/actions/ticketApprovalAction';
import {
  getApprovalTicket,
  searchApprovalTicket,
} from 'services/ticketServices';
import BaseAction from '../actions/baseAction';

export function* getListApprovalTicket(action: any): any {
  try {
    const result = yield call(getApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(TicketApprovalAction.getListApprovalTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketApprovalAction.getListApprovalTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_APPROVAL_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListApproval(action: any): any {
  try {
    const result = yield call(getApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(TicketApprovalAction.getMoreListApprovalSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketApprovalAction.getMoreListApprovalFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_APPROVAL ${error}`,
      }),
    );
  }
}

export function* searchApprovalsTicket(action: any): any {
  try {
    const result = yield call(searchApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(TicketApprovalAction.searchApprovalTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketApprovalAction.searchApprovalTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `SEARCH_APPROVAL_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListApprovalWithSearch(action: any): any {
  try {
    const result = yield call(searchApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(TicketApprovalAction.getMoreListApprovalSuccessWithSearch(result.data));
    }
  } catch (error) {
    yield put(TicketApprovalAction.getMoreListApprovalWithSearchFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_APPROVAL_WITH_SEARCH ${error}`,
      }),
    );
  }
}

export const watchTicketApproval = [
  takeLatest(TicketApprovalTypes.GET_LIST_APPROVAL_TICKET, getListApprovalTicket),
  takeLatest(TicketApprovalTypes.GET_MORE_LIST_APPROVAL, getMoreListApproval),
  takeLatest(TicketApprovalTypes.SEARCH_APPROVAL_TICKET, searchApprovalsTicket),
  takeLatest(
    TicketApprovalTypes.GET_MORE_LIST_APPROVAL_WITH_SEARCH,
    getMoreListApprovalWithSearch,
  ),
];
